import styled from 'styled-components';

export const Page = styled.div``;

export const Header = styled.section`
  max-width: ${({ theme }) => theme.container};
  margin: 24px auto 0; padding: 0 16px;
  display: grid; grid-template-columns: 1fr 1fr; gap: 16px;
  @media (max-width: 900px){ grid-template-columns: 1fr; }
`;

export const HeaderCard = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.gray[200]};
  border-radius: 12px; padding: 18px;
  h1{ margin: 0 0 6px; color: ${({ theme }) => theme.colors.green[700]}; }
  p{ margin: 0; }
`;

export const HeaderImage = styled.div`
  border-radius: 12px; overflow: hidden; background: ${({ theme }) => theme.colors.gray[100]}; min-height: 220px;
  img{ width:100%; height:100%; object-fit: cover; }
`;

export const Section = styled.section`
  max-width: ${({ theme }) => theme.container};
  margin: 24px auto 0; padding: 0 16px;
`;

export const SectionTitle = styled.h2`
  color: ${({ theme }) => theme.colors.green[700]};
  margin: 0 0 16px;
  padding-bottom: 8px;
  border-bottom: 3px solid ${({ theme }) => theme.colors.orange[500]};
  display: inline-block;
`;

export const Grid = styled.div`
  display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 16px;
`;

export const Card = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.gray[200]};
  border-radius: 12px; overflow: hidden; text-align: center; padding-bottom: 12px;
  img{ width:100%; height: 200px; object-fit: cover; }
  h3{ margin: 10px 0 4px; color: ${({ theme }) => theme.colors.green[700]}; }
  a{ color: ${({ theme }) => theme.colors.orange[700]}; }
`;
